import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import {
  startRegistration,
  startAuthentication,
  browserSupportsWebAuthn,
} from "@simplewebauthn/browser";
import { setToken } from "../lib/api";

/* Wrapper hooks/components for passkeys. */

export function usePasskeysAvailable() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        if (!browserSupportsWebAuthn()) {
          setAvailable(false);
          return;
        }
        const r = await api.get("/passkeys/available");
        setAvailable(!!r.data.available);
      } catch {
        setAvailable(false);
      }
    })();
  }, []);
  return available;
}

export function useMyPasskeys() {
  const [list, setList] = useState([]);
  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/passkeys");
      setList(r.data);
    } catch {
      setList([]);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return { list, refresh };
}

export async function registerPasskey(nickname = "this device") {
  const opts = await api.post("/passkeys/register/begin");
  try {
    const attResp = await startRegistration({ optionsJSON: opts.data });
    await api.post("/passkeys/register/complete", {
      ...attResp,
      nickname,
    });
    return true;
  } catch (err) {
    if (err?.name === "NotAllowedError" || err?.name === "AbortError") {
      toast("Passkey registration was gently cancelled.");
    } else {
      toast(err?.message || "Passkey registration didn't complete.");
    }
    throw err;
  }
}

export async function signInWithPasskey(email) {
  const opts = await api.post("/passkeys/authenticate/begin", { email });
  try {
    const assertion = await startAuthentication({ optionsJSON: opts.data });
    const r = await api.post("/passkeys/authenticate/complete", assertion);
    setToken(r.data.token);
    return r.data.user;
  } catch (err) {
    if (err?.name === "NotAllowedError" || err?.name === "AbortError") {
      toast("Passkey sign-in was gently cancelled.");
    } else {
      toast(err?.response?.data?.detail || err?.message || "Passkey sign-in didn't complete.");
    }
    throw err;
  }
}
